import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-hf-contact-section',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './hf-contact-section.component.html',
  styleUrls: ['./hf-contact-section.component.scss']
})
export class HfContactSectionComponent {
  @Input() info;
  constructor() {}

  ngOnInit() {}
}
